module.exports = __webpack_public_path__ + "img/zlindex19.4b246c93.png";